module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductDateOfStorage":{"dropdownLink":"Další naskladnění","dropdownHeader":"Budoucí naskladnění","dropdownRowText":"Očekáváme {date}","nearestAmount":"Na cestě {amount} {unit}","nearestDate":"Očekáváme {date}"}},"en":{}}')
  delete Component.options._Ctor
}
